import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import { MediaItemV2, isAerialImage } from '../../../../../app-kit/components/Image/types';
import { Image } from '../../../../../app-kit/components/Image/Image';
import { useMediaGalleryCarousel } from '../../../../contexts/MediaGalleryCarouselContext/MediaGalleryCarouselContext';
import { usePreloadSlideImage } from '../MediaGalleryCarousel/hooks/usePreloadSlideImage';

const SwiperZoomContainer = styled.div<{ $isZoomed?: boolean }>`
  height: 100%;
  display: flex;
  justify-content: center;

  ${({ $isZoomed }) => $isZoomed && `cursor: grab;`}
`;

const SwiperZoomTarget = styled.div<{ $controlsHidden: boolean }>`
  position: relative;
  height: 100%;

  ${({ $controlsHidden }) =>
    !$controlsHidden &&
    css`
      /*
        Max width is:
        Each button takes up 48px + 1rem margin each side (80px)
        So full width - 2x buttons
      */
      max-width: calc(100% - 160px);
      margin: 0 auto;
    `}

  img {
    object-fit: scale-down;
  }
`;

const AerialImageWrap = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  img {
    max-width: 100%;
  }
`;

export const MediaGalleryCarouselSlide: FunctionComponent<{ mediaItem: MediaItemV2 }> = ({
  mediaItem: { image },
}) => {
  const { isZoomed, isTouchScreen } = useMediaGalleryCarousel();
  const isAnAerialImage = isAerialImage(image);
  usePreloadSlideImage(image);

  return (
    <>
      <SwiperZoomContainer className="swiper-zoom-container" $isZoomed={isZoomed}>
        <SwiperZoomTarget className="swiper-zoom-target" $controlsHidden={isTouchScreen}>
          {isAnAerialImage ? (
            <AerialImageWrap>
              <img src={image.uri} alt={image.alt} loading="lazy" />
            </AerialImageWrap>
          ) : (
            <Image mediaItem={image} />
          )}
        </SwiperZoomTarget>
      </SwiperZoomContainer>
      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
    </>
  );
};
